import { Locale, Translation } from 'locale'
import { isEmpty } from 'lodash'
import { DefaultClipboardProcessor } from 'view/components/datagrid/ClipboardProcessor'

export class CollateralGridClipboardProcessor extends DefaultClipboardProcessor {
  HEADERS_TO_REMOVE = [Locale.translate(Translation.TC_EMPTY_HEADER)]

  getHeaderRow(rows: string[]) {
    return rows[0]
  }

  getFilteredRowToCellsTransformer(headerRow: string): (row: string) => string[] {
    const idxsToOmit = [
      1,
      ...headerRow
        .split('\t')
        .reduce<number[]>(
          (colIdxsToOmit, cell, idx) => (this.HEADERS_TO_REMOVE.includes(cell) ? [...colIdxsToOmit, idx] : colIdxsToOmit),
          []
        )
    ]
    return (row: string) => {
      const cells = row.split('\t')
      const filteredCells = cells.filter((_, idx) => !idxsToOmit.includes(idx))
      return filteredCells.every(c => isEmpty(c)) ? [] : filteredCells
    }
  }
}
